import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import $ from "jquery";
import CarousalCard from "./CarousalCard";
import ContentModule from "../../modules/content_module";
import Slider from "react-slick";

import "./ServiceContentCard.scss";


const ServiceContentCard = ({Module, GQLPage}) => {

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        focusOnSelect: true,
        afterChange: (event) => {
            var activeDotEl = $('.service_content_card .slick-slider').find('.slick-dots').find('li.slick-active');
            if(activeDotEl.get(0)){
                activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
            
        },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };



    return (
        <>
            <section className={"service_content_card"}>
                <Container>
                    <Row>
                        <Col>

                            {Module?.title_content && 
                                <ContentModule Content={Module?.title_content} />
                            }                            

                            {Module?.service_card?.length > 0 && 
                            <div className="service_content_inner">
                                <Slider  {...settings}>
                                    {Module?.service_card?.map((item, index) => (
                                        <CarousalCard key={index} item={item} increment={index+1}  />
                                    ))}
                                </Slider>
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default ServiceContentCard;